// libraries and utilities
import { put, call, takeEvery} from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { NegaraListResponse } from "./types";

import * as negaraActions from "./negara.actions";

export function* getNegara(
  action: ReturnType<typeof negaraActions.getNegaraAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'negara';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: NegaraListResponse = yield call(result.json.bind(result));
      yield put(negaraActions.getNegaraAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(negaraActions.getNegaraAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(negaraActions.getNegaraAsync.failure(parsed));
  }
}

export default function* negaraSagaGetNegara() {
  yield takeEvery(negaraActions.getNegaraAsync.request, getNegara);
}
